import { cn } from "@/lib/utils";

export const ScoreBadge = ({ score }) => {
  if (score === null || score === undefined) return null;
  const colorCls =
    score >= 71 ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/25" :
    score >= 41 ? "bg-amber-500/15 text-amber-400 border-amber-500/25" :
                  "bg-red-500/15 text-red-400 border-red-500/25";
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center min-w-[2rem] px-1.5 py-0.5 rounded-sm text-[10px] font-bold border",
        colorCls
      )}
    >
      {score}
    </span>
  );
};
